import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { asChakraVariable, keyboardFocusRing } from '@mangovoice/design-system'
import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export enum TextButtonVariants {
  Gray_900 = 'Gray_900',
  Gray_1300 = 'Gray_1300',
  Info = 'Info',
}

const TextButtonParts = ['container', 'icon', 'text'] as const

const helpers = createMultiStyleConfigHelpers(TextButtonParts)
export const TextButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: (props: { iconSize?: string }) => ({
    container: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '0.5rem',
      px: '0.25rem',
      py: 0,
      background: 'transparent',
      height: 'auto',
      marginLeft: '-0.25rem',
      cursor: 'pointer',
      _hover: {
        backgroundColor: 'transparent',
      },
      _active: {
        backgroundColor: 'transparent',
      },
      ...keyboardFocusRing,
      _focusVisible: {
        borderRadius: '3px',
      },
    },
    icon: {
      boxSize: props.iconSize ?? '1rem',
      color: 'brand.fg',
      _groupHover: {
        color: 'brand.emphasized',
      },
      _groupActive: {
        color: 'brand.emphasized',
      },
    },
    text: {
      ...textStyles[textStyleKeys.Body2_Bold],
      lineHeight: '1.25rem',
      color: 'brand.fg',
      _groupHover: {
        color: 'brand.emphasized',
      },
      _groupActive: {
        color: 'brand.emphasized',
      },
    },
  }),
  variants: {
    [TextButtonVariants.Gray_900]: {
      text: {
        color: `${asChakraVariable('fg.subtle')}`,
      },
      icon: {
        color: `${asChakraVariable('fg.subtle')}`,
      },
    },
    [TextButtonVariants.Gray_1300]: {
      text: {
        color: `${asChakraVariable('fg.default')}`,
      },
      icon: {
        color: `${asChakraVariable('fg.default')}`,
      },
    },
    [TextButtonVariants.Info]: {
      text: {
        color: `${asChakraVariable('fg.info')}`,
      },
      icon: {
        color: `${asChakraVariable('fg.info')}`,
      },
    },
  },
})

export const useTextButtonStyle = (
  props?: StyleThemingProps & { iconSize?: string },
) => {
  return mergeMultiStyleConfig(TextButtonStyle, props) as MultiStyleType<
    typeof TextButtonParts
  >
}
